interface JournalEntryRef {
    id: string;
}

interface CountableScheduleApplication {
    creationJournalEntry: JournalEntryRef | null;
    periods: Array<{ journalEntry: JournalEntryRef | null }>;
    lifecycleJournalEntries: JournalEntryRef[];
}

/**
 * Every journal entry a remove or replace would delete: the creation entry,
 * one per posted period, and every lifecycle entry (PRO-11569 OQ-001).
 */
export function countScheduleApplicationJournalEntries(
    application: CountableScheduleApplication,
): number {
    const recognitionCount = application.periods.filter(
        (period) => period.journalEntry != null,
    ).length;
    const creationCount = application.creationJournalEntry == null ? 0 : 1;
    return (
        creationCount +
        recognitionCount +
        application.lifecycleJournalEntries.length
    );
}
